import AddressSearchApi from '../../backyard/customer_informations/AddressSearchApi'
import { registerBeforeUnload } from '../../../src/before_unload'

const setFullAddress = (value: string, prefectures, setResult, setRelatedCities, setErrorMsg, type) => {
  var result = {prefectureCode: "", cityName: "", townName: ""}
  if(value.match(/^[0-9]{7}$/)){
    AddressSearchApi.getAddress({zipcode: value})
      .then((response) => {
        if (response.data["code"] === 200) {
          const foundPrefectureCode = prefectures.find((prefecture) => prefecture[0] === response.data["data"].pref)[1]
          result.prefectureCode = foundPrefectureCode
          setCities(foundPrefectureCode, setRelatedCities)
          result.cityName = response.data["data"].city
          result.townName = response.data["data"].town
          setResult(result)
          setErrorMsg("")
        } else {
          setErrorMsg("該当する郵便番号が見つかりませんでした。")
        }
      })
      .catch(() => {
        setErrorMsg(type != "backyard" ? "" : "住所検索に失敗しました。")
      })
  } else {
    setErrorMsg("7桁の数字で入力してください")
  }
}

const setCities = (targetPrefectureCode: string, setRelatedCities, defaultPrefectureCode = undefined) => {
  fetch(`${location.origin}/cities?prefecture_code=${targetPrefectureCode}`)
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok')
      return response.json();
    })
    .then((data) => {
      if (data.cities.length === 0) {
        setRelatedCities({ cities: [''] })
      } else {
        setRelatedCities(data)
      }

      // 初期表示時のみ登録
      if (targetPrefectureCode === undefined || defaultPrefectureCode === targetPrefectureCode) {
        registerBeforeUnload()
      }
  })
}

export default {
  setFullAddress,
  setCities,
}
